import { Binder } from '@ribajs/core'

/**
 * This binder adds `odd` and `even` classes to table `tr` elements
 */
export class NutrientTableBinder extends Binder<boolean, HTMLElement> {
  /** The name of the attribute, in this case you can use this binder with `rv-nutrient-table="true"` */
  static key = 'nutrient-table'

  /** This method is called every time the attribute values changes */
  routine(el: HTMLElement, enable: boolean) {
    const nutrientDataTableRow = el.querySelectorAll('.nutrition-row')
    nutrientDataTableRow.forEach((item, index) => {
      if (enable) {
        if (index % 2 === 0) {
          item.classList.add('odd')
        } else {
          item.classList.add('even')
        }
      } else {
        item.classList.remove('odd', 'even')
      }
    })
  }
}
